import { Loader } from 'lucide-react'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useOrgsApi } from 'src/api/db/apiOrgs'
import posthog from 'posthog-js'

import { useAuth } from '../../hooks/authProvider'
import { TEMP_AGENT_FORCE_LOGGED_IN } from '../../hooks/tempAgentAuthBypass'
import { paths } from '../../../routes/paths'

export const ProtectedRoute = ({ component, ...args }: any) => {
  const { loading, session } = useAuth()
  const { organization } = useOrgsApi({})

  // PostHog tracking - must run before early returns to keep hook order consistent
  useEffect(() => {
    const userId = session?.user?.id
    if (
      userId &&
      import.meta.env.PROD &&
      typeof posthog !== 'undefined' &&
      posthog.__loaded
    ) {
      const email = session?.user?.email || ''
      const orgName = organization?.data?.name || ''
      try {
        posthog.identify(userId, { email, organization_name: orgName })
        posthog.capture('$set', { $set: { email, organization_name: orgName } })
        if (organization?.data?.id) {
          posthog.group('organization', organization.data.id.toString(), {
            name: orgName,
            created_at: organization.data.created_at,
          })
        }
      } catch (error) {
        console.error('PostHog identify error:', error)
      }
    }
  }, [
    session?.user?.id,
    session?.user?.email,
    organization?.data?.id,
    organization?.data?.name,
    organization?.data?.created_at,
  ])

  // Show loader while auth is loading
  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader className="animate-spin" />
      </div>
    )
  }

  // If no session, redirect to login
  if (!session?.user?.id) {
    return <Navigate to={paths.loginSignUp} replace />
  }

  // Show loader while organization data is loading (Supabase returns { data, error }, not status)
  if (
    !TEMP_AGENT_FORCE_LOGGED_IN &&
    (!organization?.data || organization?.error)
  ) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader className="animate-spin" />
      </div>
    )
  }

  // Render the protected component
  const Component = component
  return <Component {...args} />
}
